'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';

import { filterMainBannerItems } from '../../_utils/filterMainBannerItems';
import { DesktopMainBannerSection } from '../DesktopMainBannerSection';

interface MainBannerSectionClientProps {
  className?: string;
}

export const MainBannerSectionClient = ({
  className,
}: MainBannerSectionClientProps) => {
  const { entry } = useWebviewTypeEntry();

  const { data: bannerItems } = useSuspenseQuery({
    ...UnauthQueryOptions[
      'get:/wello/v2/allows/home/institution-event/ordered'
    ]({
      query: {
        excludeEndedYN: true,
        entry,
      },
    }),
    select: (res) => {
      const list = res.context?.contents ?? [];

      return filterMainBannerItems(list, entry);
    },
    retry: 3,
  });

  return (
    <DesktopMainBannerSection
      bannerItems={bannerItems}
      className={className}
    />
  );
};
